// Color-graded chip styling for a 0-100 score, shared across patient-board UI.
export function getScoreStyles(score: number): { bgcolor: string; color: string } {
  if (score >= 80) return { bgcolor: '#E8F5E9', color: '#1B5E20' };
  if (score >= 60) return { bgcolor: '#FFF3E0', color: '#E65100' };
  return { bgcolor: '#FFEBEE', color: '#B71C1C' };
}
